import React, { useState } from 'react';
import styles from './clientPopup.module.css';
import getClients from '../../api/clients/getClients';
import getBirthDateFromIIN from '../../utils/getBirthDateFromIIN';

// components
import Modal from '../Modal/Modal';
import ClientCheck from '../ClientCheck/ClientCheck';
import HookForm from '../HookForm/HookForm';
import Datepicker from '../Inputs/Datepicker/Datepicker';
import SelectPhoto from '../../pages/Client/NewClient/ClientCreate/SelectPhoto/SelectPhoto';
import Select from '../Select/Select';
import SelectPhoneType from '../Selects/SelectPhoneType';
import SelectAddressType from '../Selects/SelectAddressType';
import SelectSocialType from '../Selects/SelectSocialType';
import SelectClientType from '../Selects/SelectClientType';
import SelectCity from '../Selects/SelectCity';
import Loader from '../Loader/Loader';

// icons
import phoneIcon from '../../brand/generated/input/phone.svg';

import { phone, iin } from '../../constants/mask';

const formStyles = {
  mainData: { display: 'grid', gap: '20px', gridTemplateAreas: `'a a a ' 'b b b ' 'k k c' 'd d d'` },
  contacts: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px',
  },
  comment: { display: 'grid', gap: '20px' },
};

const ClientPopup = ({ clientId, isOpen, setOpen }) => {
  const [photo, setPhoto] = useState();
  const [mainData, setMainData] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [comment, setComment] = useState([]);
  const [loading, setLoading] = useState(true);

  React.useEffect(() => {
    getClients({ id: clientId })
      .then((res) => {
        const client = res.data.users[0];
        console.log(client);
        const [day, month, year] = getBirthDateFromIIN(client.iin).split('.');
        const mainData = [
          {
            name: 'surname',
            label: 'Ð¤Ð°Ð¼Ð¸Ð»Ð¸Ñ*',
            placeholder: 'Ð¤Ð°Ð¼Ð¸Ð»Ð¸Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
            defaultValue: client.surname,
            disabled: true,
          },
          { name: 'name', label: 'ÐÐ¼Ñ*', placeholder: 'ÐÐ¼Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ°', defaultValue: client.name, disabled: true },
          {
            name: 'middlename',
            label: 'ÐÑÑÐµÑÑÐ²Ð¾',
            placeholder: 'ÐÑÑÐµÑÑÐ²Ð¾ (ÐµÑÐ»Ð¸ ÐµÑÑÑ)',
            defaultValue: client.middlename,
            disabled: true,
          },
          {
            name: 'iin',
            label: 'ÐÐÐ*',
            placeholder: '_ _ _ _ _ _ _ _ _ _ _',
            mask: iin,
            defaultValue: client.iin,
            disabled: true,
          },
          {
            component: Datepicker,
            name: 'born',
            label: 'ÐÐ°ÑÐ° ÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ',
            placeholder: 'Ð´Ð´-Ð¼Ð¼-Ð³Ð³Ð³Ð³',
            defaultValue: new Date(year, month, day),
            disabled: true,
          },
          {
            component: Select,
            label: 'Ð¯Ð·ÑÐº',
            placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
            name: 'languageId',
            options: [
              { value: 1, label: 'ÐÐ°Ð·Ð°ÒÑÐ°' },
              { value: 2, label: 'Ð ÑÑÑÐºÐ¸Ð¹' },
            ],
            disabled: true,
            defaultValue: { value: client?.language?.id, label: client?.language?.title },
          },
          {
            name: 'phoneNumber_',
            label: 'ÐÐ¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð°',
            placeholder: '+7(___) ___-__-__',
            mask: phone,
            defaultValue: client.phone[1] === '7' ? client.phone : client.phone.substring(1),
            disabled: true,
            icon: phoneIcon,
          },
          // {
          //   component: SelectClientType,
          //   name: 'vip',
          //   disabled: true,
          //   defaultValue: client.vip ? { value: 1, label: 'VIP' } : { value: 2, label: 'ÐÐ¾ÑÑÐµÐ´Ð½Ð¸Ðº' },
          // },
          {
            component: SelectCity,
            name: 'city',
            label: 'ÐÐ¾ÑÐ¾Ð´',
            disabled: true,
            defaultValue: { value: client?.city?.id, label: client?.city?.title },
          },
        ];

        const contacts = [
          {
            name: 'email',
            label: 'E-mail',
            placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð°Ð´ÑÐµÑ ÑÐ»ÐµÐºÑÑÐ¾Ð½Ð½Ð¾Ð¹ Ð¿Ð¾ÑÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
            style: { width: '48.5%' },
            defaultValue: client.email,
            disabled: true,
          },
          {
            name: 'url',
            label: 'URL ÑÐ°Ð¹ÑÐ°',
            placeholder: 'Ð¡Ð°Ð¹Ñ ÐºÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ð¸ ÐºÐ»Ð¸ÐµÐ½ÑÐ°',
            style: { width: '49%' },
            disabled: true,
          },
        ];
        client.phones.forEach((phoneItem, index) => {
          contacts.push(
            {
              component: SelectPhoneType,
              name: `phoneType_${index}`,
              defaultValue: [
                { value: 1, label: 'ÐÐ¾Ð±Ð¸Ð»ÑÐ½ÑÐ¹' },
                { value: 2, label: 'ÐÐ¾Ð¼Ð°ÑÐ½Ð¸Ð¹' },
                { value: 3, label: 'ÐÐ¾ÑÐ¿Ð¾ÑÐ°ÑÐ¸Ð²Ð½ÑÐ¹' },
              ].filter((item) => item.value === phoneItem.typeId)[0],
              style: { width: '30%' },
              disabled: true,
            },
            {
              name: `phoneNumber_${index}`,
              label: 'ÐÐ¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð°',
              placeholder: '+7(___) ___-__-__',
              mask: phone,
              style: { width: '67.5%' },
              defaultValue: phoneItem.number.substring(1),
              disabled: true,
              icon: phoneIcon,
            }
          );
        });
        client.addresses.forEach((address, index) => {
          contacts.push(
            {
              component: SelectAddressType,
              name: `addressType_${index}`,
              defaultValue: [
                { value: 1, label: 'ÐÐ¾Ð¼Ð°ÑÐ½Ð¸Ð¹' },
                { value: 2, label: 'ÐÐ¾ÑÐ¿Ð¾ÑÐ°ÑÐ¸Ð²Ð½ÑÐ¹' },
              ].filter((item) => item.value === address.typeId)[0],
              style: { width: '30%' },
              disabled: true,
            },
            {
              name: `address_${index}`,
              label: 'ÐÐ´ÑÐµÑ',
              placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð°Ð´ÑÐµÑ',
              style: { width: '67.5%' },
              defaultValue: address.address,
              disabled: true,
            }
          );
        });
        client.socials.forEach((social, index) => {
          contacts.push(
            {
              component: SelectSocialType,
              name: `socialType_${index}`,
              defaultValue: [
                { value: 1, label: 'Facebook' },
                { value: 2, label: 'VK' },
                { value: 3, label: 'Instagram' },
                { value: 4, label: 'Telegram' },
              ].filter((item) => item.value === social.typeId)[0],
              style: { width: '30%' },
              disabled: true,
            },
            {
              name: `social_${index}`,
              label: '@',
              placeholder: 'ÑÑÑÐ»ÐºÐ°',
              style: { width: '67.5%' },
              defaultValue: social.value,
              disabled: true,
            }
          );
        });

        const comments = [];
        client.comments.forEach((comment) => {
          comments.push({
            name: 'comment',
            label: 'ÐÐ°Ð¼ÐµÑÐºÐ¸/ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾ ÐºÐ»Ð¸ÐµÐ½ÑÐµ',
            placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð»ÑÐ±ÑÐµ Ð·Ð°Ð¼ÐµÑÐºÐ¸ Ð¸Ð»Ð¸ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾ ÐºÐ»Ð¸ÐµÐ½ÑÐµ',
            defaultValue: comment.comment,
            disabled: true,
          });
        });

        setMainData(mainData);
        setContacts(contacts);
        setComment(comments);
        setPhoto(client.photo);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Modal isOpen={isOpen} onRequestClose={() => setOpen(false)}>
          <div className={styles.wrapper}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <SelectPhoto photo={photo} style={{ flex: 1 }} disabled />
              <p className={styles.date} style={{ margin: '20px 0' }}>
                ÐÐ»Ð¸ÐµÐ½Ñ Ð·Ð°ÑÐµÐ³Ð¸ÑÑÑÐ¸ÑÐ¾Ð²Ð°Ð½: <span>01.09.2022</span>
              </p>
              <ClientCheck />
            </div>
            <div className={styles.forms}>
              <HookForm
                title={'ÐÐ°Ð½Ð½ÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ°'}
                grid={formStyles.mainData}
                border
                inputs={mainData}
                style={{ margin: 0 }}
                responsiveForm
              />
              <HookForm
                title={'ÐÐ¾Ð½ÑÐ°ÐºÑÐ½ÑÐµ Ð´Ð°Ð½Ð½ÑÐµ'}
                grid={formStyles.contacts}
                border
                inputs={contacts}
                style={{ margin: 0 }}
              />
              <HookForm
                title={'ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾'}
                border
                grid={formStyles.comment}
                inputs={comment}
                style={{ marginBottom: '20px', marginTop: 0 }}
                responsiveForm
              />
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default ClientPopup;
